/* ============================================================
   Keegan Allison — theme interactions
   - mobile menu
   - scroll reveal
   - AJAX cart drawer (Shopify Cart API)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-shown)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-shown'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-shown'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    var menu = document.getElementById('mobile-menu');
    if (!menu) return;
    document.querySelectorAll('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { menu.classList.add('is-open'); });
    });
    document.querySelectorAll('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { menu.classList.remove('is-open'); });
    });
  }

  /* ---------- cart drawer ---------- */
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  };

  function openDrawer() { var d = document.getElementById('cart-drawer'); if (d) d.classList.add('is-open'); }
  function closeDrawer() { var d = document.getElementById('cart-drawer'); if (d) d.classList.remove('is-open'); }

  function renderCart(cart) {
    var count = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });

    var body = document.getElementById('cart-drawer-body');
    if (!body) return;

    if (count === 0) {
      body.innerHTML =
        '<div class="drawer__empty">' +
          '<div class="drawer__empty-head">your cart’s empty</div>' +
          '<div class="drawer__empty-sub">go find something to keep you company.</div>' +
          '<button class="btn-fill" data-drawer-close style="width:auto;padding:12px 24px;margin-top:8px">Keep browsing</button>' +
        '</div>';
      bindClose(body);
      return;
    }

    var lines = cart.items.map(function (it) {
      var img = it.image ? it.image : '';
      return (
        '<div class="cart-line" data-key="' + it.key + '">' +
          '<div class="cart-line__img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
          '<div style="flex:1;min-width:0">' +
            '<div class="cart-line__title">' + it.product_title + '</div>' +
            '<div class="cart-line__price">' + money(it.price) + '</div>' +
            '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:12px">' +
              '<div class="qty">' +
                '<button data-dec="' + it.key + '">−</button>' +
                '<div class="qty__val">' + it.quantity + '</div>' +
                '<button data-inc="' + it.key + '">+</button>' +
              '</div>' +
              '<button class="cart-line__remove" data-remove="' + it.key + '">remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-line__line">' + money(it.final_line_price) + '</div>' +
        '</div>'
      );
    }).join('');

    body.innerHTML =
      '<div class="drawer__items">' + lines + '</div>' +
      '<div class="drawer__foot">' +
        '<div class="subtotal-row"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<div style="font-family:var(--sans);font-size:11.5px;color:var(--dimmer);margin-top:6px">Shipping &amp; taxes calculated at checkout.</div>' +
        '<button class="btn-fill" data-checkout style="margin-top:16px">Checkout</button>' +
      '</div>';

    bindLineEvents(body);
    bindClose(body);
  }

  function bindClose(scope) {
    scope.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
  }

  function bindLineEvents(scope) {
    scope.querySelectorAll('[data-inc]').forEach(function (b) {
      b.addEventListener('click', function () { changeByKey(b.getAttribute('data-inc'), +1); });
    });
    scope.querySelectorAll('[data-dec]').forEach(function (b) {
      b.addEventListener('click', function () { changeByKey(b.getAttribute('data-dec'), -1); });
    });
    scope.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { updateByKey(b.getAttribute('data-remove'), 0); });
    });
    var co = scope.querySelector('[data-checkout]');
    if (co) co.addEventListener('click', function () { window.location.href = '/checkout'; });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeByKey(key, delta) {
    getCart().then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      updateByKey(key, Math.max(0, item.quantity + delta));
    });
  }

  function updateByKey(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) { return r.json(); })
      .then(function () { return getCart(); })
      .then(function (cart) { renderCart(cart); openDrawer(); });
  }

  function initCart() {
    // open/close
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    var overlay = document.getElementById('cart-drawer');
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeDrawer(); });

    // quantity stepper (delegated) — used on the product page
    document.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-qty-inc]');
      var dec = e.target.closest('[data-qty-dec]');
      if (!inc && !dec) return;
      var scope = (inc || dec).closest('[data-add-scope]') || document;
      var val = scope.querySelector('[data-qty-val]');
      if (!val) return;
      var n = parseInt(val.textContent, 10) || 1;
      n = inc ? n + 1 : Math.max(1, n - 1);
      val.textContent = n;
    });

    // add-to-cart buttons (delegated)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-variant]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-add-variant');
      var qtyEl = btn.closest('[data-add-scope]') && btn.closest('[data-add-scope]').querySelector('[data-qty-val]');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
      btn.disabled = true;
      addToCart(id, qty).finally(function () { btn.disabled = false; });
    });

    // initial paint
    getCart().then(renderCart);
  }

  // expose for inline use if needed
  window.KAcart = { open: openDrawer, close: closeDrawer, add: addToCart, refresh: function () { getCart().then(renderCart); } };

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMenu();
    initCart();
  });
})();
